import { Italic as OriginalItalic } from "@tiptap/extension-italic";

import { remapShortcuts } from "./utils/remapShortcuts";

export const Italic = OriginalItalic.extend(
  remapShortcuts({
    "Mod+KeyI": ({ editor }) => editor.commands.toggleItalic(),
  }),
);
